import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import DigitalniUsluge from "./digitalni-usluge";

const DigitalniMarketing = () => {
  useEffect(() => {
    document.title =
      "Digitalni marketing Split | SEO, Google Ads i društvene mreže | Prokurator";
    return () => {
      document.title =
        "Prokurator | Digitalni marketing i vanjsko oglašavanje Split";
    };
  }, []);

  return (
    <div>
      <div className="intro-area" style={{ paddingTop: "50px" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="section-title text-center">
                <h1 className="title">
                  Digitalni marketing u Splitu i Hrvatskoj
                </h1>
                <p>
                  Tražite partnera koji jednako radi digitalni marketing i
                  vanjsko oglašavanje? Prokurator spaja SEO, Google Ads,
                  društvene mreže i izradu web stranica s mrežom od 500+
                  oglasnih površina. Cilj je jednostavan: da vas klijenti
                  pronađu na Googleu, zapamte na Instagramu i vide na
                  najprometnijim lokacijama — od Splita i Dalmacije do cijele
                  Hrvatske.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="single-intro style-two">
                <h4 className="intro-title">Što radimo</h4>
                <p>
                  Planiramo i vodimo digitalne kampanje: SEO optimizaciju,
                  plaćeno oglašavanje (Google Ads, Meta Ads), content marketing,
                  vođenje profila na društvenim mrežama i web stranice
                  spremne za pretraživače. Svaka usluga ima mjerljiv cilj —
                  pozicije, upiti, pozivi ili prodaja.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="single-intro style-two">
                <h4 className="intro-title">Zašto Prokurator</h4>
                <p>
                  Digitalni marketing i vanjsko oglašavanje držimo ravnopravnima.
                  Billboardi, wallscape, city lightovi i putokazi nisu dodatak
                  — ista poruka ide na Google, društvene mreže i na ulicu.
                  Jedan tim, oba kanala.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="intro-area pd-top-80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-title text-center mb-0">
                <h2 className="title">Usluge digitalnog marketinga</h2>
                <p>
                  SEO, Google Ads, Facebook i Instagram oglasi, content
                  marketing, izrada web stranica i analitika. Online kanal koji
                  stoji uz vanjsko oglašavanje, ne umjesto njega.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DigitalniUsluge showCta={false} showIntro={false} />

      <div className="blog-list-area pd-bottom-70">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-title text-center">
                <h2 className="title">Kako radimo digitalnu kampanju</h2>
                <p>
                  Bez šablona. Prvo slušamo posao i tržište, zatim biramo kanale
                  — SEO, Google Ads, Facebook i Instagram oglase ili web — i
                  pratimo rezultate dok se brojke ne pomaknu.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="digital-process-step">
                <span className="step-num">01</span>
                <h4>Analiza i ključne riječi</h4>
                <p>
                  Istražujemo kako vas klijenti traže: ključne riječi,
                  konkurenciju i trenutačnu vidljivost na Googleu i društvenim
                  mrežama.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="digital-process-step">
                <span className="step-num">02</span>
                <h4>Strategija i izvedba</h4>
                <p>
                  Slažemo mix: SEO, PPC, sadržaj, web i vanjsko
                  oglašavanje. Kampanje palimo, sadržaj objavljujemo, plohe
                  postavljamo.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="digital-process-step">
                <span className="step-num">03</span>
                <h4>Mjerenje i rast</h4>
                <p>
                  Pratimo analitiku, trošak po rezultatu i upite. Optimiziramo
                  oglase i sadržaj dok digitalni marketing ne postane
                  predvidljiv kanal rasta.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="video-area tp-video-area"
        style={{
          backgroundImage:
            "url(" + process.env.PUBLIC_URL + "/assets/img/bg/20.png)",
          paddingTop: "70px",
          paddingBottom: "80px",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-title text-center mb-0">
                <h2 className="title" style={{ color: "#fff" }}>
                  Online i offline u jednoj priči
                </h2>
                <p style={{ color: "#f1f1f1" }}>
                  Digitalni marketing donosi precizno ciljanje: tko vidi oglas,
                  što klikne, koliko košta upit. Vanjsko oglašavanje gradi
                  svijest — billboard u Splitu, Zadru ili Rijeci vidi tisuće
                  ljudi svaki dan. Zajedno rade jače: Google vas nađe kad
                  netko traži uslugu, a ploha na cesti potvrđuje brend koji
                  već poznaje.
                </p>
                <Link
                  className="btn btn-yellow"
                  to="/kontakt"
                  style={{ marginTop: "28px" }}
                >
                  Zatražite ponudu{" "}
                  <i className="fa fa-paper-plane" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalniMarketing;
